import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

// Material UI
import { withStyles, Paper } from '@material-ui/core';

import AuthUserContainer from '../../containers/AuthUser';
import EnhancedTable from '../../components/table/EnhancedTable';
import FilterHeader from '../../components/table/FilterHeader';
import { getGlobalClasses } from '../../themes';
import DeviceTokenEvent from '../../containers/Dispatch/DeviceTokenEvent';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
	};
};

class DeviceEvents extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 'asc',
			orderBy: 'dateCreated',
		};
	}

	componentDidMount() {
		const { deviceTokenEvents, searchDeviceTokenEvents } = this.props;

		console.log('deviceTokenEvents', deviceTokenEvents);
		if (!deviceTokenEvents) {
			searchDeviceTokenEvents({
				params: {},
			});
		} else {
			this.formatDeviceTokenEvents();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { deviceTokenEvents } = this.props;
		if (prevProps.deviceTokenEvents !== deviceTokenEvents) {
			this.formatDeviceTokenEvents();
		}
	}

	handleSnackbarClose = (_event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ snackbarIsOpen: false });
	};

	formatDeviceTokenEvents = () => {
		//const { classes } = this.props;
		const { deviceTokenEvents, userMap } = this.props;

		const deviceTokenEventsFormatted = deviceTokenEvents.map((event) => {
			const { deviceTokenEventId, userId, deviceToken, eventType, dateCreated } = event;

			const user = userMap[userId] || { firstName: 'Missing', lastName: '' };

			return {
				key: deviceTokenEventId,
				deviceTokenEventId,
				userId,
				userDisplay: `${user.firstName} ${user.lastName}`,
				deviceTokenPart: deviceToken.substring(0, 15) + '...',
				eventType,
				dateCreated,
				dateCreatedDisplay: moment(dateCreated).format('M/D h:mm a'),
			};
		});

		this.setState({
			deviceTokenEventsFormatted,
		});
	};

	render() {
		const { classes } = this.props;
		const { deviceTokenEventsFormatted } = this.state;

		if (!deviceTokenEventsFormatted) {
			return (
				<div>
					<span style={{ fontSize: 24, padding: 20, fontWeight: 300, color: '#666' }}>
						Fetching Device Events...
					</span>
				</div>
			);
		}

		const columns = [
			{ label: 'ID', sortId: 'deviceTokenEventId', displayId: 'deviceTokenEventId' },
			{ label: 'Employee', sortId: 'requestorDisplay', displayId: 'userDisplay' },
			{ label: 'Type', sortId: 'typeDisplay', displayId: 'eventType' },
			{ label: 'Date', sortId: 'totalDaysSort', displayId: 'dateCreatedDisplay' },
			{ label: 'Device Id', sortId: 'rangeSort', displayId: 'deviceTokenPart' },
		];

		return (
			<Fragment>
				<FilterHeader
					label={
						<span>
							Mobile Events <span style={{ fontSize: '40%' }}>(last 5 days)</span>
						</span>
					}
					canMakeUpdates={true}
				/>
				<Paper className={classes.globalMainPaper}>
					<div>Last 10 days</div>
					<EnhancedTable
						rows={deviceTokenEventsFormatted}
						columns={columns}
						isDense={true}
						defaultOrder={'desc'}
						defaultOrderBy={'dateCreated'}
					/>
				</Paper>
			</Fragment>
		);
	}
}

DeviceEvents.propTypes = {
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	userMap: PropTypes.object,
	searchDeviceTokenEvents: PropTypes.func.isRequired,
	deviceTokenEvents: PropTypes.array,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	DeviceTokenEvent,
])(DeviceEvents);
